export const AllSectors = [
    { value: 0, label: 'Aeronáutica'},
    { value: 1, label: 'Agrícola agronegócio e saúde animal'},
    { value: 2, label: 'Saúde e Fármacos, Biotecnologia'},
    { value: 3, label: 'Combustíveis'},
    { value: 4, label: 'Defesa'},
    { value: 5, label: 'Educação'},
    { value: 6, label: 'Energia'},
    { value: 7, label: 'IoT'},
    { value: 8, label: 'Industria 4.0'},
    { value: 9, label: 'Mineração'},
    { value: 10, label: 'Ambiental'},
    { value: 11, label: 'Automotivo'},
    { value: 12, label: 'Propriedade Intelectual'},
    { value: 13, label: 'Projetos com parcerias (ICT, Universidade ou Startups'},
    { value: 14, label: 'Telecom'},
    { value: 15, label: 'Inovação e Infraestrutura'},
    { value: 16, label: 'Outros' }
]

